export type ThemePreference = "auto" | "light" | "dark";
export type ResolvedTheme = "light" | "dark";

export const THEME_STORAGE_KEY = "council-theme-v1";
export const DARK_MODE_QUERY = "(prefers-color-scheme: dark)";

export function parseThemePreference(value: string | null): ThemePreference {
  return value === "light" || value === "dark" ? value : "auto";
}

export function readThemePreference(): ThemePreference {
  try { return parseThemePreference(window.localStorage.getItem(THEME_STORAGE_KEY)); }
  catch { return "auto"; }
}

export function applyTheme(theme: ResolvedTheme) {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  const canvas = getComputedStyle(document.documentElement).getPropertyValue("--color-canvas").trim();
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", `rgb(${canvas})`);
}
